import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const num = (n) => Number(n || 0).toLocaleString();

export const STATUS = {
  nominated: { label: "Nominated", color: "#EF4444", note: "Needs preliminary review" },
  assessment: { label: "Assessment", color: "#F97316", note: "Being evaluated" },
  approval: { label: "Approval", color: "#EAB308", note: "Owner / engineering / permitting" },
  fundraising: { label: "Fundraising", color: "#3B82F6", note: "Ready for sponsors" },
  funded: { label: "Funded", color: "#A855F7", note: "Construction preparation" },
  completed: { label: "Completed", color: "#22C55E", note: "Project finished" },
};

export const ROLE_LABEL = {
  admin: "Administrator",
  sponsor: "Corporate Sponsor",
  fence_partner: "Fence Partner",
  swim_provider: "Swim Provider",
  volunteer: "Volunteer",
};

export const IMG = {
  pool: "https://images.unsplash.com/photo-1651614158095-b98b6c1da74b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  cpr: "https://images.unsplash.com/photo-1622115297822-a3798fdbe1f6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  fence: "https://images.unsplash.com/photo-1773505152933-abce5bf2b6a0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  lesson: "https://images.unsplash.com/photo-1778145079390-064ef2d1d2d8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  hero: "https://images.unsplash.com/photo-1778141580411-b651578c5acf?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  training: "https://images.unsplash.com/photo-1778141580577-a11dfebb96cc?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};
